import React from 'react';
// Import Image
import SawiHijau from '../../../assets/images/sawi-hijau-small.png';
import SawiPutih from '../../../assets/images/sawi-putih-small.png';
// Import Icon
import { ReactComponent as ArrowUpRight } from '../../../assets/icons/icon-feather-arrow-up-left.svg';
import { Link } from 'react-router-dom';

const SearchResult = () => {
  return (
    <div className="origin-top-right absolute right-0 w-full mt-12 rounded-md shadow-lg">
      <div className="rounded-md bg-white shadow-xs  pt-2 pb-3 shadow-sm">
        <div
          className="py-1"
          role="menu"
          aria-orientation="vertical"
          aria-labelledby="options-menu"
        >
          <div className="flex flex-col">
            <Link
              to="/sawi"
              className="flex items-center px-6 py-2 hover:bg-orange-100"
            >
              <img alt="Sawi Hijau" src={SawiHijau} className="w-12 h-12  mr-4" />
              <p className="text-font-gray ">Sawi Hijau</p>
              <ArrowUpRight className="ml-auto w-3 h-3" />
            </Link>
            <Link
              to="/sawi"
              className="flex items-center px-6 py-2 hover:bg-orange-100"
            >
              <img alt="Sawi Hijau" src={SawiPutih} className="w-12 h-12  mr-4" />
              <p className="text-font-gray">Sawi Putih</p>
              <ArrowUpRight className="ml-auto w-3 h-3" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchResult;
